/*
 * Online Help behaviour. Two independent, self-guarding pieces, each a no-op
 * when its markup is absent:
 *
 *  1. Docs-reader tree    (.help-nav)      - collapsible chapters, plus a
 *     client-side page filter (the sidebar box narrows the tree by title; it
 *     is NOT the full-text search, which lives on the hub / global search).
 *  2. Collection switcher (.help-nav-switch select) - navigate to the chosen
 *     handbook on change.
 *
 * The "on this page" rail and copy-link button are handled by
 * content-reading.js (the reader reuses .content-prose / .content-rail).
 */
(function () {
    var nav = document.querySelector('.help-nav');
    if (nav) {
        // ── 1. Docs-reader chapter tree ─────────────────────────────────
        // Collapse / expand a chapter (clicking the toggle, not the title link).
        nav.querySelectorAll('.help-chapter-h .help-chapter-toggle').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                btn.closest('.help-chapter').classList.toggle('collapsed');
            });
        });

        // Long handbooks scroll the chapter tree; bring the current page into
        // view so the reader can see where they are without hunting for it.
        // Only .help-tree-scroll scrolls now (the switcher/search sit above it),
        // so center the active item within that container.
        var scroller = nav.querySelector('.help-tree-scroll');
        var active = nav.querySelector('.help-pg.active, .help-chapter-link.active');
        if (scroller && active && scroller.scrollHeight > scroller.clientHeight) {
            var aRect = active.getBoundingClientRect();
            var sRect = scroller.getBoundingClientRect();
            scroller.scrollTop += (aRect.top - sRect.top) - scroller.clientHeight / 2 + aRect.height / 2;
        }

        // ── Page filter ─────────────────────────────────────────────────
        // Narrow the tree by title as the reader types: matching pages stay,
        // their chapter expands, non-matching chapters hide. A chapter title
        // match keeps all of that chapter's pages. Clearing restores the
        // initial collapsed state. This is a filter, not a full-text search.
        var filterBox = nav.querySelector('[data-help-filter]');
        if (filterBox) {
            var input = filterBox.querySelector('input');
            var clearBtn = filterBox.querySelector('.ls-search-clear');
            var empty = nav.querySelector('[data-help-empty]');
            var searchBase = filterBox.getAttribute('data-search-url');

            // Snapshot the tree once - lowercased titles/page text and each
            // chapter's initial collapsed state - so a keystroke is a plain walk
            // (no re-querying or re-lowercasing the DOM every time).
            var chapters = [];
            nav.querySelectorAll('.help-chapter').forEach(function (el) {
                var pages = [];
                el.querySelectorAll('.help-pg').forEach(function (pg) {
                    pages.push({ el: pg, text: pg.textContent.toLowerCase() });
                });
                chapters.push({
                    el: el,
                    title: el.getAttribute('data-title') || '',
                    collapsed: el.classList.contains('collapsed'),
                    pages: pages
                });
            });

            // Build the "no matches" card once; a keystroke only updates its text.
            var emptyMsg, emptyBtn;
            if (empty) {
                var icon = document.createElement('i');
                icon.className = 'icon-search-x help-tree-empty-icon';
                icon.setAttribute('aria-hidden', 'true');
                emptyMsg = document.createElement('p');
                emptyMsg.className = 'help-tree-empty-msg';
                empty.appendChild(icon);
                empty.appendChild(emptyMsg);
                if (searchBase) {
                    emptyBtn = document.createElement('a');
                    emptyBtn.className = 'help-tree-empty-btn';
                    var btnIcon = document.createElement('i');
                    btnIcon.className = 'icon-search';
                    btnIcon.setAttribute('aria-hidden', 'true');
                    emptyBtn.appendChild(btnIcon);
                    emptyBtn.appendChild(document.createTextNode('Search all help'));
                    empty.appendChild(emptyBtn);
                }
            }

            var applyFilter = function () {
                var q = input.value.trim().toLowerCase();
                var anyChapter = false;
                chapters.forEach(function (ch) {
                    var titleMatch = !!q && ch.title.indexOf(q) !== -1;
                    var anyPage = false;
                    ch.pages.forEach(function (pg) {
                        var match = !q || titleMatch || pg.text.indexOf(q) !== -1;
                        pg.el.hidden = !match;
                        if (q && match) anyPage = true;
                    });
                    if (!q) {
                        ch.el.hidden = false;
                        ch.el.classList.toggle('collapsed', ch.collapsed);
                    } else {
                        ch.el.hidden = !(titleMatch || anyPage);
                        if (!ch.el.hidden) { anyChapter = true; ch.el.classList.remove('collapsed'); }
                    }
                });
                // Nothing in this guide matches - offer a full-text search of all
                // the help for exactly what was typed.
                if (empty) {
                    empty.hidden = !(q && !anyChapter);
                    if (!empty.hidden) {
                        var qv = input.value.trim();
                        emptyMsg.textContent = 'No pages match “' + qv + '”';
                        if (emptyBtn) emptyBtn.href = searchBase + '?q=' + encodeURIComponent(qv);
                    }
                }
            };

            input.addEventListener('input', applyFilter);
            if (window.lsWireSearchClear) {
                window.lsWireSearchClear(input, clearBtn, applyFilter);
            }
        }
    }

    // ── 2. Mobile "Contents" disclosure ─────────────────────────────────
    // On phones the chapter tree sits above the article; keep it collapsed
    // behind a toggle so the page you opened is the first thing you see.
    var navToggle = document.querySelector('.help-nav-toggle');
    if (navToggle && nav) {
        navToggle.addEventListener('click', function () {
            var open = nav.classList.toggle('open');
            navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
    }

    // The guide switcher is a Bootstrap .dropdown of plain links now (handled by
    // Bootstrap's own JS), so it needs no wiring here.

    // Guide overview "+N more" reveals: on click, un-hide the capped extras in
    // an ancestor container, then drop the trigger. Two uses share this shape -
    // the section grid (the "+N more" tile) and each card's article list (its
    // "+N more" button). Wiring runs for buttons inside still-hidden section
    // cards too, so they work once that card is revealed.
    var wireReveal = function (triggerSel, containerSel, extraSel, removeSel) {
        document.querySelectorAll(triggerSel).forEach(function (trigger) {
            trigger.addEventListener('click', function () {
                var container = trigger.closest(containerSel);
                if (container) {
                    container.querySelectorAll(extraSel).forEach(function (el) {
                        el.hidden = false;
                    });
                }
                (trigger.closest(removeSel) || trigger).remove();
            });
        });
    };
    wireReveal('[data-help-more]', '[data-help-sections]', '.help-overview-card-extra[hidden]', '.help-overview-more');
    wireReveal('[data-art-more]', '[data-art-list]', '.help-overview-art-extra[hidden]', '.help-overview-art-morewrap');

    // ── 3. "Was this page helpful?" feedback ────────────────────────────
    // Posts a single vote to the beacon endpoint and swaps the buttons for a
    // thank-you. Remembers the page in localStorage so a return visit isn't
    // asked again (best-effort: storage may be unavailable in private mode).
    var feedback = document.querySelector('[data-help-feedback]');
    if (feedback) {
        var url = feedback.getAttribute('data-url');
        var articleId = feedback.getAttribute('data-article');
        var storeKey = 'help-feedback-' + articleId;

        var done = function () {
            feedback.querySelector('.help-feedback-q').hidden = true;
            feedback.querySelector('.help-feedback-btns').hidden = true;
            feedback.querySelector('.help-feedback-thanks').hidden = false;
        };

        var voted = false;
        try { voted = window.localStorage.getItem(storeKey) !== null; } catch (e) {}
        if (voted) done();

        feedback.querySelectorAll('[data-help-vote]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var helpful = btn.getAttribute('data-help-vote');
                var body = new FormData();
                body.append('article', articleId);
                body.append('helpful', helpful);
                fetch(url, {method: 'POST', body: body, keepalive: true}).catch(function () {});
                try { window.localStorage.setItem(storeKey, helpful); } catch (e) {}
                done();
            });
        });
    }
})();
